import { render, staticRenderFns } from "./NavNextIcon.vue?vue&type=template&id=b9215886"
import script from "./NavNextIcon.vue?vue&type=script&lang=js"
export * from "./NavNextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports